<template>
    <card-table :title="displayedTitle">
        <template slot="title-buttons">
            <slot name="title-buttons"></slot>
            <input
                v-model="search"
                class="form-control pull-right"
                placeholder="Search"
                style="width: 300px;display: inline-block;"
                @keyup.enter="startSearch()" />
        </template>
        <template slot="thead">
            <slot name="header"></slot>
        </template>
        <template slot="tbody">
            <tr v-if="fetching">
                <td :colspan="headerCount">
                    <i class="fa fa-spinner fa-spin pr-1"></i>
                    Loading data, please wait ...
                </td>
            </tr>
            <tr v-else-if="recordsEmpty">
                <td :colspan="headerCount">
                    No record was found
                </td>
            </tr>
            <tr v-else v-for="(record, key) in pagination.data" :key="key">
                <slot name="body" :record="record" :mixins="self" :refresh-page="refreshPage"></slot>
            </tr>
        </template>
        <template slot="footer">
            <pagination
                v-if="(pagination.last_page || pagination.last) > 1"
                :simplified="simplified"
                :total-pages="pagination.last_page || pagination.last"
                :total="pagination.total"
                :current-page="pagination.current_page"
                @pageChanged="pageChanged"
            ></pagination>
        </template>
    </card-table>
</template>
<script>
// import mixins from 'utils/mixins';
const CardTable = () => import('./CardTable.vue');
const Pagination = () => import('./Pagination.vue');
import axios from "axios"

export default {
    name: 'CardPaginatedTable',
    components: { CardTable, Pagination },

    
    computed: {
        displayedTitle() {
            return this.searched ? `Search results for "${ this.lastSearch }"` : this.title;
        },

        displayedPages() {
            let pages = [];
            for (let page = 1; page <= (this.pagination.last_page || this.pagination.last); page++) {
                pages.push(this.formatPageData(page));
            }
            return pages;
        },

        headerCount() {
            return this.$slots.header ? this.$slots.header.length : 1;
        },

        recordsEmpty() {
            return this.pagination.data && this.pagination.data.length == 0;
        },

    },

    props: {
        title: String,
        fetchLink: String,
        paginatePath: {
            type: String,
            default: "",
        },
        simplified: { type: Boolean, default: false },
    },

    // mixins: [mixins],

    data: () => ({
        link: '',
        fetching: true,
        currentPage: 0,
        pagination: {},
        self: {},
        search: "",
        searched: false,
        lastSearch: "",
    }),

    methods: {
        getPageClass(isActive) {
            return {
                'active': isActive,
                'page-item': true,
            };
        },
        
        startSearch() {
            this.searched = !!this.search && this.search.length > 0
            this.link = this.fetchLink;
            this.fetchData();
        },

        formatPageData(pageNumber) {
            return {
                active: this.currentPage == pageNumber,
                link: `${ this.pagination.path }?page=${ pageNumber }`,
                name: pageNumber,
            };
        },

        fetchData() {
            this.fetching = true;
            let params = this.searched ? { search: this.lastSearch = this.search  } : {};
            axios(this.link, { params })
                .then(response => this.mapData(response))
                .catch(error => this.fetchFailed(error))
                .finally(() => this.fetching = false);
        },

        fetchFailed(error) {
            this.$emit('fetch-failed', error);
            this.promptErrors(error.response.data.message);
            this.pagination = { data: [] };
        },

        mapData(response) {
            this.pagination =this.getPaginationFromPath(response);
            this.currentPage = this.pagination.current_page;
        },

        getPaginationFromPath(data) {
            this.paginatePath.split('.')
                .forEach(index => data = data[index]);
            return data;
        },
        
        movePage(event) {
            event.preventDefault();
            this.link = event.target.href
            this.currentPage = parseInt(event.target.dataset.page)
            this.fetchData();
        },

        refreshPage() {
            if (this.pagination.data.length <= 1) {
                let page = this.pagination.current_page - 1;
                this.link = this.pagination.path +
                    '?page=' + (page <= 0 ? 1 : page);
            }
            this.fetchData();
        },
        pageChanged(page){
            event.preventDefault();
            this.link = this.pagination.path +
                '?page=' + page;
            this.fetchData();
        },

    },


    mounted() {
        this.self = this;
        this.link = this.fetchLink;
        this.fetchData();
    },
}
</script>
